import { Text } from '@components/index';
import { cloneStyled } from '@utils/cloneStyled';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  row-gap: 16px;
  column-gap: 8px;

  flex-wrap: wrap;

  .AssetMobileTagList_list {
    display: flex;
    row-gap: 16px;
    column-gap: 8px;
    flex-wrap: wrap;
  }
`;

export const TagListCount = cloneStyled(
  Text,
  styled(Text)`
    padding: 4px 12px;
    background-color: var(--beam-color-neutral-n200);
    border-radius: 15px;
  `,
);
